import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

const Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="#ADADAD"
  >
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path fill="none" d="M0 0h24v24H0z" />
  </svg>
);

const CloseButton = ({ closeToast }) => (
  <ButtonTransparent type="button" onClick={closeToast}>
    <Icon />
  </ButtonTransparent>
);

const ButtonTransparent = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
`;

CloseButton.propTypes = {
  closeToast: PropTypes.func,
};

CloseButton.defaultProps = {
  closeToast: () => null,
};

export default CloseButton;
